import { useLazyQuery } from '@apollo/client';
import type { UseLalSegmentsWithDetailsFetch } from '@openx/components-segment/lib/utils/context/SegmentHookTypes';
import { useCallback } from 'react';
import { GetLalSegmentsWithDetailsDocument } from '../../../graphql/query/segments/lal/GetLalSegmentsWithDetails.generated';

export const useLalSegmentsWithDetailsFetch: UseLalSegmentsWithDetailsFetch = () => {
  const [getLalSegmentsWithDetails] = useLazyQuery(GetLalSegmentsWithDetailsDocument);

  const fetchLalSegmentsWithDetails = useCallback(
    async (segmentIds: string[]) => {
      const { loading, data: { lookalike_definitions = [] } = {} } = await getLalSegmentsWithDetails({
        fetchPolicy: 'network-only',
        variables: {
          segmentIds,
        },
      });

      return {
        loading,
        lalSegments: lookalike_definitions,
      };
    },
    [getLalSegmentsWithDetails]
  );

  return {
    fetchLalSegmentsWithDetails,
  };
};
